<template>
  <router-view />
</template>

<script>
  import { components } from 'aws-amplify-vue'
  import axios from 'axios'
  import { EventBus } from './event-bus'

  export default {
    name: 'App',
    components: {
      ...components,
    },
    mounted() {
      EventBus.$on('errors', (payload) => {
        this.$router.push({
          name: 'errors',
          params: {
            error: payload.errors,
            displayRefreshBtn: payload.displayRefreshBtn || false,
            displayLogoutBtn: payload.displayLogoutBtn || false,
          },
        })
      })
      axios.interceptors.response.use(
        function (response) {
          return response
        },
        function (error) {
          // temporary fix to not intercept 403 errors from SSO.
          // TODO: refactor to use a separate axios instance for auth and API calls
          if (error.response && error.response.status && error.response.status === 403 && error.response.data.message.includes('User is not authorized')) {
            EventBus.$emit('refreshModal')
          }
          return Promise.reject(error)
        }
      )
    },
  }
</script>

<style>
  #app {
    /*text-align: center;*/
    text-overflow: ellipsis;
    max-width: 100%;
  }

  body {
    text-transform: uppercase;
  }

  ::-webkit-scrollbar {
    width: 5px;
    border-radius: 10px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: var(--v-primary-base);
    border-radius: 5px;
  }
</style>
